const TIPOS_DILIGENCIAS = [
  {
    id: 1,
    name: 'Créditos'
  },
  {
    id: 2,
    name: 'Sueldos'
  },
]

export {
  TIPOS_DILIGENCIAS
}
